var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "address-settings" } }, [
    _c("div", { staticClass: "form-field" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "field-label" } },
        [_vm._v(_vm._s(_vm.$t("form.fieldLabel")))]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.fieldAddress,
            expression: "fieldAddress",
          },
        ],
        staticClass: "form-input",
        attrs: {
          type: "text",
          id: "field-label",
          placeholder: _vm.$t("message.address"),
        },
        domProps: { value: _vm.fieldAddress },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.fieldAddress = $event.target.value
            },
            function ($event) {
              return _vm.setFieldLabelAddress(_vm.fieldAddress)
            },
          ],
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v(_vm._s(_vm.$t("form.labelAlignment"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "button-group" }, [
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.align === "left" },
            on: {
              click: function ($event) {
                return _vm.setLabelAlignAddress("left")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("form.left")))]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.align === "right" },
            on: {
              click: function ($event) {
                return _vm.setLabelAlignAddress("right")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("form.right")))]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.align === "top" },
            on: {
              click: function ($event) {
                return _vm.setLabelAlignAddress("top")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("form.top")))]
        ),
      ]),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v(_vm._s(_vm.$t("form.chooseLabelAlignment"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v(_vm._s(_vm.$t("form.required"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "toggle" }, [
        _c(
          "span",
          {
            staticClass: "toggle-option",
            class: { active: _vm.isRequired },
            on: { click: _vm.toggleRequired },
          },
          [_vm._v(_vm._s(_vm.requiredText))]
        ),
      ]),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v(_vm._s(_vm.$t("form.fieldEmptyError"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [_vm._v("Görünürlük")]),
      _vm._v(" "),
      _c("div", { staticClass: "toggle" }, [
        _c(
          "span",
          {
            staticClass: "toggle-option",
            class: { active: _vm.visibility },
            on: { click: _vm.toggleVisibility },
          },
          [_vm._v(_vm._s(_vm.visibility ? "Görünür" : "Gizli"))]
        ),
      ]),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v("Bu alanın form üzerinde görünür olup olmayacağını belirler"),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label", attrs: { for: "slug-input" } }, [
        _vm._v("URL Parametresi"),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.slug,
            expression: "slug",
          },
        ],
        staticClass: "form-input",
        attrs: { type: "text", id: "slug-input", placeholder: "address" },
        domProps: { value: _vm.slug },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.slug = $event.target.value
            },
            function ($event) {
              return _vm.setSlug($event.target.value)
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v("URL parametrelerinde kullanılacak benzersiz tanımlayıcı"),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v(_vm._s(_vm.$t("form.subLabels"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sub-labels" }, [
        _c("div", { staticClass: "sub-label-item" }, [
          _c(
            "label",
            { staticClass: "sub-label", attrs: { for: "address-line-1" } },
            [_vm._v(_vm._s(_vm.$t("form.addressLine1")))]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.addressLine1,
                expression: "addressLine1",
              },
            ],
            staticClass: "sub-label-input",
            attrs: {
              type: "text",
              id: "address-line-1",
              placeholder: _vm.$t("form.addressLine1"),
            },
            domProps: { value: _vm.addressLine1 },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.addressLine1 = $event.target.value
                },
                function ($event) {
                  return _vm.setFieldAddressLine1(_vm.addressLine1)
                },
              ],
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sub-label-item" }, [
          _c(
            "label",
            { staticClass: "sub-label", attrs: { for: "address-line-2" } },
            [_vm._v(_vm._s(_vm.$t("form.addressLine2")))]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.addressLine2,
                expression: "addressLine2",
              },
            ],
            staticClass: "sub-label-input",
            attrs: {
              type: "text",
              id: "address-line-2",
              placeholder: _vm.$t("form.addressLine2"),
            },
            domProps: { value: _vm.addressLine2 },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.addressLine2 = $event.target.value
                },
                function ($event) {
                  return _vm.setFieldAddressLine2(_vm.addressLine2)
                },
              ],
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sub-label-item" }, [
          _c(
            "label",
            { staticClass: "sub-label", attrs: { for: "district" } },
            [_vm._v(_vm._s(_vm.$t("akinon.city")))]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.district,
                expression: "district",
              },
            ],
            staticClass: "sub-label-input",
            attrs: {
              type: "text",
              id: "district",
              placeholder: _vm.$t("akinon.city"),
            },
            domProps: { value: _vm.district },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.district = $event.target.value
                },
                function ($event) {
                  return _vm.setFieldDistrict(_vm.district)
                },
              ],
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sub-label-item" }, [
          _c(
            "label",
            { staticClass: "sub-label", attrs: { for: "postal-code" } },
            [_vm._v(_vm._s(_vm.$t("form.postalCode")))]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.postalCode,
                expression: "postalCode",
              },
            ],
            staticClass: "sub-label-input",
            attrs: {
              type: "text",
              id: "postal-code",
              placeholder: _vm.$t("form.postalCode"),
            },
            domProps: { value: _vm.postalCode },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.postalCode = $event.target.value
                },
                function ($event) {
                  return _vm.setFieldPostalCode(_vm.postalCode)
                },
              ],
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sub-label-item" }, [
          _c("label", { staticClass: "sub-label", attrs: { for: "state" } }, [
            _vm._v(_vm._s(_vm.$t("form.stateProvince"))),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.state,
                expression: "state",
              },
            ],
            staticClass: "sub-label-input",
            attrs: {
              type: "text",
              id: "state",
              placeholder: _vm.$t("form.stateProvince"),
            },
            domProps: { value: _vm.state },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.state = $event.target.value
                },
                function ($event) {
                  return _vm.setFieldState(_vm.state)
                },
              ],
            },
          }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }